import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';

// Global Icons map -> content to avoid re-requesting icons when unneeded.
var LOADED_ICONS = new Map();
/**
 * Component that injects inline SVG icons stored in /icons folder which
 * allows to have control over icon color, stroke and other decorative
 * attributes.
 */
var IconComponent = /** @class */ (function (_super) {
    __extends(IconComponent, _super);
    function IconComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.svg = null;
        _this.attributes = {};
        _this.isMounted = false;
        _this.displayAltText = false;
        return _this;
    }
    IconComponent.prototype.loadSvg = function () {
        return __awaiter(this, void 0, void 0, function () {
            var assetPath, path, svgText, parser, doc, attributes, _i, _a, attribute;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.name || !this.path) {
                            return [2 /*return*/];
                        }
                        this.clearElement();
                        this.isMounted = false;
                        assetPath = this.magicConfig.paths
                            ? this.magicConfig.paths.assets.svg
                            : this.path;
                        path = assetPath + "/" + this.name + ".svg";
                        // Cache and load the icon.
                        if (!LOADED_ICONS.has(path)) {
                            LOADED_ICONS.set(path, fetch(path).then(function (resp) {
                                var contentType = resp.headers.get('Content-Type');
                                if (!contentType ||
                                    !contentType.includes('image/svg+xml')) {
                                    console.warn("Could not load SVG as '" + contentType + "' content type is incorrect: " + path);
                                    return 'Error';
                                }
                                return resp.text();
                            }));
                        }
                        return [4 /*yield*/, LOADED_ICONS.get(path)];
                    case 1:
                        svgText = _b.sent();
                        parser = new DOMParser();
                        doc = parser.parseFromString(svgText, 'image/svg+xml');
                        this.svg = doc.documentElement;
                        if (this.svg.nodeName !== 'svg') {
                            console.warn("SVG '" + path + "' did not contain an SVG element");
                            return [2 /*return*/, this.altTextFallback()];
                        }
                        this.mountSvgContent();
                        attributes = {};
                        for (_i = 0, _a = Array.from(this.svg.attributes); _i < _a.length; _i++) {
                            attribute = _a[_i];
                            this.$set(attributes, attribute.nodeName, attribute.nodeValue);
                        }
                        this.attributes = attributes;
                        return [2 /*return*/];
                }
            });
        });
    };
    IconComponent.prototype.onAttributesChange = function () {
        for (var _i = 0, _a = Object.keys(this.$attrs); _i < _a.length; _i++) {
            var attribute = _a[_i];
            this.$set(this.attributes, attribute, this.$filteredAttrs[attribute]);
        }
    };
    IconComponent.prototype.clearElement = function () {
        if (!this.$refs.svg) {
            return;
        }
        // Clear element
        var svgRef = this.$refs.svg;
        while (svgRef.firstChild) {
            svgRef.removeChild(svgRef.firstChild);
        }
    };
    IconComponent.prototype.mounted = function () {
        this.mountSvgContent();
    };
    IconComponent.prototype.mountSvgContent = function () {
        if (!this.svg || !this.$refs.svg || this.isMounted) {
            return;
        }
        var svg = this.svg;
        var nodes = svg.children;
        var svgRef = this.$refs.svg;
        this.clearElement();
        for (var _i = 0, _a = Array.from(nodes); _i < _a.length; _i++) {
            var node = _a[_i];
            svgRef.appendChild(node);
        }
        this.isMounted = true;
    };
    IconComponent.prototype.altTextFallback = function () {
        this.displayAltText = this.altText ? true : false;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], IconComponent.prototype, "name", void 0);
    __decorate([
        Prop({ type: String, default: '/img/icons' }),
        __metadata("design:type", String)
    ], IconComponent.prototype, "path", void 0);
    __decorate([
        Prop({ type: String, default: 'div' }),
        __metadata("design:type", String)
    ], IconComponent.prototype, "tag", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], IconComponent.prototype, "badge", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], IconComponent.prototype, "altText", void 0);
    __decorate([
        Watch('path', { immediate: true }),
        Watch('name', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], IconComponent.prototype, "loadSvg", null);
    __decorate([
        Watch('$attrs', { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], IconComponent.prototype, "onAttributesChange", null);
    IconComponent = __decorate([
        Component({
            inheritAttrs: false,
            name: 'ui-icon',
        })
    ], IconComponent);
    return IconComponent;
}(Mixins(MagicConfigMixin)));

export default IconComponent;
